/**
 * Read&Write for Google Chrome
 *
 * Splits its resources across 12 WAR entries with different scopes. Notably it ships
 * functions/getIfInstalled.js — a helper whose whole purpose is answering "is this
 * extension installed?" — but that one is correctly scoped to docs.google.com and
 * classroom.google.com, so it is not usable from an arbitrary page.
 *
 * The onboarding UI and page-world bundles are the resources actually exposed to
 * <all_urls>, so the probes use those. (An earlier version of this module probed
 * getIfInstalled.js and failed verification — a good argument for checking which WAR
 * entry a resource belongs to, not just that it is listed somewhere.)
 *
 * Manifest verified against version 2.1.988.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'inoeonmfapjbbkmdafoankkfajkcphgd';
export const readAndWrite: ExtensionDefinition = {
  id: ID,
  name: 'Read&Write for Google Chrome™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'Ships a purpose-built "is it installed?" helper, but correctly scopes it to Google ' +
    'Docs/Classroom. Detection instead uses the onboarding UI, which is exposed to every origin.',
  signals: [
    { id: 'war-onboarding-html', kind: 'web-accessible-resource',
      description: 'Fetch onboarding/onboarding.html — the first-run UI, exposed to <all_urls>.',
      weight: 1, run: () => probeFetch(ID, 'onboarding/onboarding.html') },
    { id: 'war-gdocs-page-bundle', kind: 'web-accessible-resource',
      description: 'Fetch gdocs.page.bundle.js — a page-world bundle exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'gdocs.page.bundle.js') },
  ],
};
